import {getElementById} from '../dom-utils';
import createOrderForm from '../functions/createOrderForm';
import initFormControls from './initFormControls';

export default function initOrderForm() {
    const orderComponent = getElementById('os-order');
    const orderForm = getElementById('os-order-form');

    if (!orderComponent || !orderForm) return;

    const orderFormUpdates$ = createOrderForm(orderComponent, orderForm, '.triggerable-controls input');

    orderFormUpdates$.subscribe(initFormControls);
    return orderFormUpdates$;
}
